// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pafnmppyisnhfqfozjag.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBhZm5tcHB5aXNuaGZxZm96amFnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNTIwNzksImV4cCI6MjA3MTcyODA3OX0.Jmu-5CvQ8lxBEdJp0IEoP75t1JQenViMBHI8MqciTAE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});